import React from 'react';

import logo from 'assets/images/logo.png';
import './Login.style.scss';

import ResetForm from 'components/pages/ResetPassword/form';
import { useTranslation } from 'react-i18next';
import LangSwitch from 'components/MainNav/LangSwitch';

const ForgotPassword = () => {
  const { t } = useTranslation();
  return (
    <div className="Login">
      <div className="form">
        <div className="d-flex-end langSwitch">
          <LangSwitch />
        </div>
        <div className="logoContainer">
          <div className="recenterLogo logo m-auto d-block">
            <img className="resizeLogo" src={logo} alt="logo assolia" />
          </div>
        </div>
        <div className="container">
          <p className="text-center title">{t('form.newPassword')}</p>
          <ResetForm />
        </div>
      </div>
      <div className="img" />
    </div>
  );
};

export default ForgotPassword;
